"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decode = exports.encode = void 0;
var tslib_1 = require("tslib");
var color_1 = tslib_1.__importDefault(require("color"));
function encode(color, siteColors) {
    if (color.name) {
        var wixColor = siteColors.find(function (c) { return c.name === color.name; });
        var rgbColor = (0, color_1.default)(wixColor.value)
            .alpha(color.opacity)
            .rgb()
            .string();
        return {
            opacity: color.opacity,
            rgba: rgbColor,
            color: {
                value: rgbColor,
                name: wixColor.name,
                reference: wixColor.reference,
            },
        };
    }
    var parsedColor = (0, color_1.default)(color.value);
    return {
        opacity: color.opacity,
        rgba: parsedColor
            .alpha(color.opacity)
            .rgb()
            .string(),
        color: false,
    };
}
exports.encode = encode;
function decode(color, siteColors) {
    if (!color.value) {
        return null;
    }
    if (color.themeName) {
        var wixColor = siteColors.find(function (c) { return c.reference === color.themeName || c.name === color.themeName; });
        var parsedColor = (0, color_1.default)(color.value || wixColor.value);
        if (wixColor) {
            return {
                value: parsedColor.rgb().string(),
                name: wixColor.name,
                opacity: parsedColor.valpha,
            };
        }
    }
    var parsedOriginalColor = (0, color_1.default)(color.value);
    return {
        value: parsedOriginalColor.rgb().string(),
        name: null,
        opacity: parsedOriginalColor.valpha,
    };
}
exports.decode = decode;
//# sourceMappingURL=WixStyleColors.js.map